// extracted by mini-css-extract-plugin
module.exports = {"badgeSection":"badgesection-module--badgeSection--1T3HX","inverted":"badgesection-module--inverted--iPMyF","badge":"badgesection-module--badge--2OX2p"};